/* esm.sh - bip174@2.1.1 */
import "/node/buffer.mjs";
export * from "/*bip174@2.1.1/esnext/bip174.mjs";
export { default } from "/*bip174@2.1.1/esnext/bip174.mjs";
